<template>
  <div class="progress-text-area" style="position:relative">
    <ValidationProvider v-slot="v" rules="" :name="vp.name">
      <textarea
        class="form-control comment-field__control"
        :class="{ 'is-valid': v.touched && v.passed }"
        rows="7"
        :placeholder="placeholder"
        :value="value"
        @input="updateValue($event.target.value)"
      ></textarea>
    </ValidationProvider>
    <!-- <div v-if="insufficientText" class="alert alert-warning text-center">'Durchschnittlich geben Seminarteilnehmer mehr Text ein.</div> -->
    <div class="progress comment-field__progress" style="display: flex;">
      <div class="progress-bar" role="progressbar" :style="{width: percentage + '%', background: progressColor}" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';

export default {
  name: 'ProgressTextArea',
  props: ['value', 'vp', 'placeholder'],
  components: { ValidationProvider },
  data() {
    return {
      text: '',
      maxTextLength: 300,
    }
  },
  methods: {
    updateValue(value) {
      this.$emit('input', value);
    },
    calculateColor(progress) {
      const colors = [
        {'r': 169,  'g': 68,  'b': 66},
        {'r': 241,  'g': 133, 'b': 26},
        {'r': 237,  'g': 195, 'b': 62},
        {'r': 237,  'g': 195, 'b': 62},
        {'r': 60,   'g': 118, 'b': 61},
        {'r': 60,   'g': 118, 'b': 61},
        {'r': 60,   'g': 118, 'b': 61},
        {'r': 60,   'g': 118, 'b': 61}
      ];

      let index = Math.floor(progress / 13.2);
      if (index >= colors.length - 1) {
        return `rgb(${colors[colors.length - 1].r}, ${colors[colors.length - 1].g}, ${colors[colors.length - 1].b})`;
      }

      let color1 = colors[index], color2 = colors[index + 1];
      let t = (progress - index * 13.2) / 13.2;

      let r = Math.round(color1.r + t * (color2.r - color1.r));
      let g = Math.round(color1.g + t * (color2.g - color1.g));
      let b = Math.round(color1.b + t * (color2.b - color1.b));

      return `rgb(${r}, ${g}, ${b})`;
    }
  },
  computed: {
    percentage() {
      return Math.min(5 + (this.value.length / this.maxTextLength) * 100, 100);
    },
    progressColor() {
      return this.calculateColor(this.percentage);
    },
    insufficientText() {
      return this.value.length > 0 && this.value.length < 150;
    }
  }
}
</script>

<style scoped>
.comment-field__control {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.comment-field__progress {
  height: 0.5rem;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>